import { convertUsdToCurrency, getCurrencySymbol } from "../../lib/currency";
import type { CurrencyCode, InputDescriptor } from "../../lib/types";

export type FieldKind = InputDescriptor<string>["kind"];

interface RenderFieldArgs {
  name: string;
  label: string;
  kind: FieldKind;
  value: number;
  currency: CurrencyCode;
  step?: string;
}

function getSuffix(kind: FieldKind): string {
  if (kind === "percent") {
    return "%";
  }

  if (kind === "minutes") {
    return "min";
  }

  return "";
}

export function renderFormField(args: RenderFieldArgs): string {
  const symbol = args.kind === "currency" ? getCurrencySymbol(args.currency) : "";
  const suffix = getSuffix(args.kind);
  const displayValue =
    args.kind === "currency" ? convertUsdToCurrency(args.value, args.currency) : args.value;
  const valueText = Number.isFinite(displayValue) ? `${Number(displayValue.toFixed(2))}` : "0";

  return `
    <label class="field" for="${args.name}">
      <span>${args.label}</span>
      <span class="field-input-wrap">
        ${symbol ? `<span class="field-prefix">${symbol}</span>` : ""}
        <input
          id="${args.name}"
          name="${args.name}"
          data-field="true"
          data-kind="${args.kind}"
          value="${valueText}"
          inputmode="decimal"
          step="${args.step ?? "any"}"
          autocomplete="off"
        />
        ${suffix ? `<span class="field-suffix">${suffix}</span>` : ""}
      </span>
    </label>
  `;
}
